import { memo } from 'react';
import { Box, Skeleton } from '@bonanza-social/moonlight';

function PromosSkeleton() {
  return (
    <Box flex={1} gap="space-400">
      <Skeleton flex={1} aspectRatio={0.8} />
      <Skeleton flex={1} aspectRatio={0.8} />
      <Skeleton flex={1} aspectRatio={0.8} />
    </Box>
  );
}

export default memo(PromosSkeleton);
